module.exports = __webpack_public_path__ + "img/options-monoplus.3cc42748.svg";